// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const Tag = zod.object({
  "id": zod.uuid(),
  "name": zod.string()
});

export type Tag = zod.input<typeof Tag>;
export type TagOutput = zod.output<typeof Tag>;
